import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { StyledBoxDown, StyledButton, StyledButtonPlus } from './style';

import HobbyItem from './HobbyItem';
import Modal from '../../../core/Modal';
import { HOBBIES } from '../../../../constants/literals/modals';
import { moveElementPosition } from '../../../../utils/splices';

class Hobbies extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: props.dataHobbies,
      btnIsDisabled: true
    };
  }

  componentDidMount() {
    const { data } = this.state;

    if (data.length === 0) {
      this.handlePlus();
    }
  }

  onClickDelete = index => {
    const { data } = this.state;
    const updatedData = data.filter((ele, i) => i !== index);

    this.setState({
      data: updatedData,
      btnIsDisabled: this.getBtnStatus(updatedData)
    });
  };

  onClickOrderArrow = (index, isDown) => {
    const { data } = this.state;
    const move = isDown ? index + 1 : index - 1;
    const updatedData = moveElementPosition([...data], index, move);

    this.setState({
      data: updatedData,
      btnIsDisabled: this.getBtnStatus(updatedData)
    });
  };

  getBtnStatus = data => {
    const { dataHobbies } = this.props;

    return _.isEqual(dataHobbies, data);
  };

  handleAccept = () => {
    const { onAcceptModal } = this.props;
    const { data } = this.state;
    const updatedData = data.filter(ele => ele.hobbyCatId && ele.hobbyId);

    onAcceptModal(updatedData);
  };

  handleChange = (event, index, type) => {
    const { data } = this.state;
    const clonedData = [...data];

    if (type === 'category') {
      clonedData[index] = {
        ...clonedData[index],
        hobbyCatId: event.id,
        hobbyCat: event.name,
        hobbyId: null,
        hobby: null
      };
    } else {
      clonedData[index] = {
        ...clonedData[index],
        hobbyId: event.id,
        hobby: event.name
      };
    }
    this.setState({
      data: clonedData,
      btnIsDisabled: this.getBtnStatus(clonedData)
    });
  };

  handlePlus = () => {
    const { data } = this.state;
    const clonedData = [...data];

    clonedData.push({
      hobbyCatId: null,
      hobbyCat: '',
      hobbyId: null,
      hobby: ''
    });

    this.setState({ data: clonedData });
  };

  render() {
    const { onCloseModal, formUser } = this.props;
    const { data, btnIsDisabled } = this.state;
    return (
      <Modal title={HOBBIES.TITLE} clickCloseIcon={onCloseModal} tabletSize>
        {data.map((item, index) => (
          <HobbyItem
            // eslint-disable-next-line
              key={`hobby-${index}`}
            formUser={formUser}
            hobbyId={item.hobbyId}
            hobbyCatId={item.hobbyCatId}
            order={index + 1}
            onClickDown={() => this.onClickOrderArrow(index, true)}
            onClickUp={() => this.onClickOrderArrow(index, false)}
            onClickDelete={() => this.onClickDelete(index)}
            onChangeHobbyCatId={e => {
              this.handleChange(e, index, 'category');
            }}
            onChangeHobbyId={e => {
              this.handleChange(e, index, 'hobby');
            }}
          />
        ))}
        <StyledButtonPlus dark onClick={this.handlePlus} tabletSize />
        <StyledBoxDown>
          <StyledButton onClick={onCloseModal} modal>
            {HOBBIES.CANCEL}
          </StyledButton>
          <StyledButton
            onClick={this.handleAccept}
            secondary
            disabled={btnIsDisabled}
          >
            {HOBBIES.ACCEPT}
          </StyledButton>
        </StyledBoxDown>
      </Modal>
    );
  }
}

Hobbies.propTypes = {
  dataHobbies: PropTypes.arrayOf(
    PropTypes.shape({
      hobbyCatId: PropTypes.number,
      hobbyCat: PropTypes.string,
      hobbyId: PropTypes.number,
      hobby: PropTypes.string
    })
  ),
  onCloseModal: PropTypes.func,
  onAcceptModal: PropTypes.func
};

Hobbies.defaultProps = {
  dataHobbies: []
};

export default Hobbies;
